<div class="input-with-tooltip" #container>
  <ng-content></ng-content>
  <span class="rounded-mark input-icon pointer"
        [ngbTooltip]="tooltipText"
        triggers="manual"
        [autoClose]="false"
        [placement]="'top-right'"
        #t="ngbTooltip">?</span>
</div>